import { IdModal } from "../../modals/IdModal";
import { createPathSelectTabInModal } from "./createPathSelectTabInModal";
export var pathOpenQuestMenu = function (action, state$, deps) { return createPathSelectTabInModal(function () { return IdModal.Quests; })(action, state$, deps); };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/path/pathOpenQuestMenu.ts
// module id = 2347
// module chunks = 3